import React from "react";
import Table from "../../components/reactTable/Table";
import { Eye } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Tooltip from "../btooltip/Tooltip";
import { fetchViewAppDetails, getMemberDetails, resetInitialTab } from "../../stores/slices/appViewDetailsSlice";

const ViewAllRequiredAction = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const requirdActionsData = useSelector(
    (state) => state.requiredActionsSlice.requirdAction
  );
  const data = requirdActionsData?.allActionData;

  const ApplicationDetails = (e, props, parameter) => {
    let data = props.row.original
    if (parameter == "actionrequired") {
      let appID = data.ApplicationID;
      let Program = "";
      if (data.ApplicationID.includes("FAF")) {
        Program = "FAF";
      } else {
        Program = "CPR";
      }
      let actionDes = data.ActionDescription;
      if (actionDes.search("Diagnosis") != -1 || 0) {
        dispatch(fetchViewAppDetails({ applicationID: appID, prgData: Program }))
        dispatch(getMemberDetails({ memberId: data.memberID, prgData: Program }))
        //  go to document page
        dispatch(resetInitialTab(5));
        navigate('/applications/Details')
      }
      if (actionDes.search("Claim") != -1 || 0) {
        dispatch(fetchViewAppDetails({ applicationID: appID, prgData: Program }))
        dispatch(getMemberDetails({ memberId: data.memberID, prgData: Program }))
        //  go to Claim page
        dispatch(resetInitialTab(7));
        navigate('/applications/Details')
      }
      else {
        dispatch(fetchViewAppDetails({ applicationID: appID, prgData: Program }))
        dispatch(getMemberDetails({ memberId: data.memberID, prgData: Program }))
        //  go to document page
        dispatch(resetInitialTab(5));
        navigate('/applications/Details')
      }
    }
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "TEST",
        accessor: "TEST",
      },
      {
        Header: "Program",
        accessor: "App",
        Cell: (props) => {
          return (<p>{props.row.original.ApplicationID.includes("FAF") ? "FAF" : "TotalAssist"}</p>)
        }
      },
      {
        Header: "Reference ID",
        accessor: "ApplicationID",
      },
      {
        Header: "Patient Name",
        accessor: "PatientName",
      },
      {
        Header: "Remaining Task",
        accessor: "ActionDescription",
      },
      {
        Header: "Complete Task",
        accessor: "actions",
        Cell: (props) => {

          return (
            <div className="d-flex justify-content-start align-items-center">
              {/* <Tooltip content={props.row.original.ActionDescription.search("Claim") != -1 || 0 ? "View Claim" : 'View Application'}> */}
              <a
                className="d-flex align-items-start completAction pointer"
                onClick={(e) => ApplicationDetails(e, props, "actionrequired")}
              >
                {" "}
                {/* <Eye /> */}
                Complete Action
              </a>
              {/* </Tooltip> */}
            </div>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <div className="intro-y g-col-12 bg_white p-4">
        <Table
          columns={columns}
          data={data}
          showPageDataCount={10}
          searchFilter={false}
        />
      </div>
    </>
  );
};

export default ViewAllRequiredAction;
